import styled from "styled-components";
import { layout } from '../../../../../package.json';

export const Root = styled.div`
  width: 100%;
  background-color: #f9f9f9;
`

export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 62rem;
  padding: 0 2%;
  margin: 0 auto;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  margin-top: 60px;
  margin-bottom: 30px;
`;

export const Title = styled.h1`
  color: #000000;
  font-size: 2rem;
  font-weight: 600;
  font-style: normal;
  letter-spacing: normal;
  line-height: normal;
  text-align: left;
  /* Text style for "Pedido #00" */
  font-style: normal;
  letter-spacing: normal;
  line-height: normal;
  display:flex;
  gap: 5px;
    justify-content: center;
  align-items: center;
  > span {
   display:flex;
  justify-content: center;
  align-items: center;
  height: 37px;
  }

  @media (max-width: ${layout.mobile}) {
      font-size:1.5rem;

      > span {
       height: 33px;
       }
  }
`;

export const SubTitle = styled.h2`
  color: #000000;
  font-size: 1.7rem;
  font-weight: 600;
  font-style: normal;
  letter-spacing: normal;
  line-height: normal;
  text-align: center;
  text-transform: uppercase;
  /* Text style for "RESUMO DO" */
  font-style: normal;
  letter-spacing: normal;
  line-height: normal;

  @media (max-width: ${layout.mobile}) {
      font-size:1.1rem;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5rem;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 50rem;
  margin: 2rem auto 3rem auto;
  padding: 0 1rem;

  @media (max-width: ${layout.mobile}) {
    gap: 0.5rem;
    flex-direction: column;
    padding: 0 2rem;
  }
`;

export const BackBtn = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  border: none;
  width: 100%;
  max-width: 180px;
  min-height: 48px;
  border-radius: 6px;
  padding: 12px 16px;

  background: #757575;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #616161;
  }

  span {
    color: #fff;
    font-weight: 600;
    font-size: 0.9rem;
    text-align: center;
    white-space: nowrap;
  }

  @media (max-width: ${layout.mobile}) {
    max-width: 100%;
    min-height: 44px;
    padding: 12px 16px;
    span {
      font-size: 0.85rem;
    }
  }
`;

export const KeepBuyingBtn = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  border: none;
  width: 100%;
  max-width: 180px;
  min-height: 48px;
  border-radius: 6px;
  padding: 12px 16px;

  background: var(--primary);
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #c53030;
  }

  span {
    color: #fff;
    font-weight: 600;
    font-size: 0.9rem;
    text-align: center;
    white-space: nowrap;
  }

  @media (max-width: ${layout.mobile}) {
    max-width: 100%;
    min-height: 44px;
    padding: 12px 16px;
    span {
      font-size: 0.85rem;
    }
  }
`;

interface CancelBtnProps {
    disabled?: boolean;
}

export const CancelBtn = styled.button<CancelBtnProps>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  border: none;
  width: 100%;
  max-width: 180px;
  min-height: 48px;
  border-radius: 6px;
  padding: 12px 16px;

  background: #424242;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: background 0.2s ease;
  opacity: ${props => props.disabled ? 0.5 : 1};

  &:hover {
    background: ${props => props.disabled ? '#424242' : '#303030'};
  }

  span {
    color: #fff;
    font-weight: 600;
    font-size: 0.9rem;
    text-align: center;
    white-space: nowrap;
  }

  @media (max-width: ${layout.mobile}) {
    max-width: 100%;
    min-height: 44px;
    padding: 12px 16px;
    span {
      font-size: 0.85rem;
    }
  }
`;

export const ContainerInfo = styled.div`
width: 100%;    
max-width: 799px;
padding: 18px;
border: 1px solid #707070;
border-radius: 10px;
display: flex;
flex-direction: column;
gap: 6px;
 & + & {
    margin-top: 12px;
  }
`

export const TitleInfo = styled.h3`
    font-size: 0.81rem;
    font-weight: bold;
`

export const SubTitleInfo = styled.p`
  font-size: 0.75rem;
  font-weight: 500;
  font-style: medium;
  color: #707070;
`

export const TextInfo = styled.span`
    font-size: 0.81rem;
    font-weight: 500;
    font-style: normal;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
`

export const ContainerTotals = styled.div`
    width: 100%;
    margin-top: 0.68rem;
    display: flex;
    flex-direction: column;
    gap: 0.68rem;

    > div {
        display: flex;
        justify-content: space-between;
    }
`

export const InfoLeft = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
`

export const ContainerProduct = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: #fff;
    padding: 18px;
    gap: 6px;
    border-radius: 10px;
`

export const ContainerImage = styled.div`
  width: 100%;
  max-width: 6rem;
  border-radius: 10px;
  width: 100%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  img {
    width: 100%;
    max-height: 6rem;
  }
`;

export const ContainerInfoProduct = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 100px;
  @media (max-width: ${layout.mobile}) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    gap: 6px;
  }
`

interface ContainerColumnProps {
  align?: "flex-start" | "center" | "flex-end" | "stretch" | "baseline";
  flexDirectionMobile?: 'row' | 'column';
  flex?: number;
}

export const InfoProduct = styled.div<ContainerColumnProps>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: ${({ align }) => align || "flex-start"};

  ${({ flex }) => flex && 'flex:1'};

  @media (max-width: ${layout.mobile}) {
    flex-direction: ${({ flexDirectionMobile }) => flexDirectionMobile || "row"};
  }
`;

export const PriceTotalProduct = styled.span`
    color: var(--primary);
    font-size: 1rem;
    font-weight: bold;
`